<form novalidate #currentForm="ngForm">
  <div class="form-group">
    <label>Type</label>
    <select class="form-control form-control-sm" required name="aka_type_id" [(ngModel)]="aka.aka_type_id">
      <option *ngFor="let akaType of formOptions.aka_types" [value]="akaType.value">{{ akaType.label }}</option>
    </select>
    <div class="invalid-feedback d-block" *ngIf="!aka.aka_type_id && formSubmitted">Type needs to be selected</div>
  </div>
  <div class="form-group">
    <label>Alias</label>
    <input type="text" name="name" [(ngModel)]="aka.name" required class="form-control form-control-sm" />
    <div class="invalid-feedback d-block" *ngIf="!aka.name && formSubmitted">Name needs to be entered</div>
  </div>
  <div class="form-row">
    <div class="col">
      <button type="button" (click)="save(currentForm)" class="btn btn-primary btn-block" [disabled]="formSubmitting">
        Save
        <span *ngIf="formSubmitting">
          &nbsp;
          <i class="fas fa-pulse fa-spinner fa-fw"></i>
        </span>
      </button>
    </div>
    <div class="col">
      <button type="button" class="btn btn-outline-secondary btn-block" [disabled]="formSubmitting" (click)="saved.emit(false)">Cancel</button>
    </div>
  </div>
</form>
